/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_More_UpdatesInputs */



/**
* | output |
* | --- |
* | "Learn More about Updates" |
*
* @param {Learn_More_UpdatesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const learn_more_updates = /** @type {((inputs?: Learn_More_UpdatesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_More_UpdatesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En savoir plus sur les mises à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erfahren Sie mehr über Updates")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scopri di più sugli aggiornamenti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Узнайте больше об обновлениях")
	if (locale === "es") return /** @type {LocalizedString} */ ("Obtenga más información sobre las actualizaciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("了解更多更新信息")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アップデートの詳細")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपडेट के बारे में और जानें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Saiba mais sobre as atualizações.")
	return /** @type {LocalizedString} */ ("Learn More about Updates")
});